import React, { Component } from 'react';
import { connect } from 'react-redux';
import {Helmet} from "react-helmet"
import {find} from './reducers/page'
import Block from './block/Block'
//import {addScrollListener,removeScrollListener} from './lib/ScrollObserver'
import {WEBSITE_NAME, LANGUAGES} from '../config'
//import NodeContent from './block/NodeContent'

class Node extends Component {
	componentDidMount() {
		let main = document.getElementById('main')
		if (main) setTimeout(() => main.childNodes[0].focus(), 500)
		/*

		document.documentElement.style.setProperty('--scroll', 0)
    	this.scroll = addScrollListener(this.onScroll.bind(this))
		this.sections = document.querySelectorAll('.node-in > div')
		this.visible = []
		if (this.sections) {
		this.sections.forEach((elem, i) => {
  			const h = window.innerHeight
    		const top = elem.getBoundingClientRect().top
			if (top<=h) {
            	if(!this.visible[i]){
                	elem.classList.add('visible')
	                this.visible[i] = true
    	        }
        	} else {
            	if(this.visible[i]){
                	elem.classList.remove('visible')
	                this.visible[i] = false
    	        }
        	}
			
		})
		}
		*/
        
	}
	componentWillMount() {
		const {node, template} = this.props
		
		this.updateTemplate(node, template)
	}
	componentWillReceiveProps({node, template}) {
		this.updateTemplate(node, template)
	}
	updateTemplate(node, template) {
		const {find} = this.props
		
		if(!node || !node.tpl || template) return
		find(node.tpl, {query: {_id: node.tpl}})
	}
	componentDidUpdate(prevProps, prevState){
		if(typeof(FB)!=='undefined') {
			const videos = document.querySelectorAll('.fb-video')
			//eslint-disable-next-line
			if (videos) videos.forEach(video => FB.XFBML.parse(video.parentNode))
			//if (videos.length>0) FB.XFBML.parse();
        }
        /*
		this.sections = document.querySelectorAll('.node-in > div')
		this.visible = []
		if (this.sections) {
		this.sections.forEach((elem, i) => {
  			const h = window.innerHeight
    		const top = elem.getBoundingClientRect().top
			if (top<=h) {
            	if(!this.visible[i]){
                	elem.classList.add('visible')
	                this.visible[i] = true
    	        }
        	} else {
            	if(this.visible[i]){
                	elem.classList.remove('visible')
	                this.visible[i] = false
    	        }
        	}
			
		})
		}
		*/
	}
    componentWillUnmount() {
        //removeScrollListener(this.scroll)
    }
    /*
    onScroll(status, scrollbar) {
		if (this.sections) {
		this.sections.forEach((elem, i) => {
	    	if(scrollbar.isVisible(elem)) {
            	//console.log('is visible')
    	        if(!this.visible[i]){
        	    	//console.log('set visible')
            	    elem.classList.add('visible')
                	this.visible[i] = true
            	}
    		} else {
            	if(this.visible[i]){
                	elem.classList.remove('visible')
	                this.visible[i] = false
    	        }
    		}
		})
		}
    }
	*/
  	render() {
  		const { node, template, lang, error } = this.props
  		if(error) {
  			return (<div className='node' id='node'>
  				<h3>{error}</h3>
  			</div>)
  		}
  		if(!node || (node.tpl && !template)) return <div className='node' id='node'/>
		
		let title = node.title
		let description = node.description
		const web_name = (LANGUAGES && typeof(WEBSITE_NAME)==='object')?WEBSITE_NAME[lang]:WEBSITE_NAME
		const renderEntity = template || node
		return (
       				<div className={`node type-${node.type}`} id='node'>
       					{title &&
       					<Helmet>
       						<title>{`${web_name} - ${title}`}</title>
       						<meta property="og:title" content={`${web_name} - ${title}`} />
       						<meta property="twitter:title" content={`${web_name} - ${title}`} />
       						{node.description && 
       							[<meta key={0} property="og:description" content={description}/>,
       							<meta key={1} property="twitter:description" content={description} />]}
						</Helmet>}
						<div className='node-in'>
							{renderEntity.grid && renderEntity.grid.filter(block => !block.p).map((block,i) =>
                    			<Block key={i} entity={node} block={block} tpl={template}/>
                			)}
						</div>
					</div>
  				);
	}
}

function mapStateToProps(state, props) {
	const {path, transition} = props
	
	let node
	if(transition) {
		if(path && state.page[path] && state.page[path].data.length>0) node = state.page[path].data[0]
	} else {
		node = state.page.node
	}
	
	if (!node) {
		if (!state.page.loading) return {error: 'Pagina nu a fost gasită.'}
		return {}
	}
	return {
		lang: state.page.lang,
		node,
		template: (node.tpl && state.page[node.tpl] && state.page[node.tpl].data.length>0)
			? state.page[node.tpl].data[0]
			: null
	}
}
export default connect(mapStateToProps, {find})(Node);



// WEBPACK FOOTER //
// ./src/fm/Node.js